import { render, staticRenderFns } from "./main-recruitment-tit.vue?vue&type=template&id=391016fc"
import script from "./main-recruitment-tit.vue?vue&type=script&lang=js"
export * from "./main-recruitment-tit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports